import { css } from '@emotion/react';
import type { ReactNode } from 'react';

import { sharedCellContainerStyle } from './styles';

const styles = {
	container: css(sharedCellContainerStyle, {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		'& svg': css({ overflow: 'visible' }),
	}),
};

/**
 * NOTE: This is a wrapper around an svg icon which
 * ensures that it lines up correctly in the table
 */
export function IconCell({ children }: { children: ReactNode }) {
	return (
		<div css={styles.container} data-testid="icon-cell">
			{children}
		</div>
	);
}
